/**
 * Created by wjy on 2018-10-11
 */
import * as React from 'react';
import { observer } from 'mobx-react/custom';
import { inject } from 'mobx-react';
import moment from 'moment';
import toast from '@util/toast';
import tool from '@util/tool';
import './index.scss';

@inject('store')
@observer
export default class QuestionDetail extends React.Component<any, any> {
    public config: any = {
        headers: {
            // 'X-CHJ-Token': window.localStorage.getItem('ACCESSTOKEN') || 'app_sign_13cf8fc55ac9407694ed46de06d49ceb',
            // 'X-CHJ-Deviceid': 'f06af636000000000'
        },
    };
    public constructor(props) {
        super(props);
        this.init();
    }
    public getDetail = (id) => {
        console.log('detail');
        this.props.store.getDetail.get(id);
    }
    public formatDate = (dataString) => {
        const dataArr = dataString.split(' ');
        const noHour = dataArr[0].split('-');
        return noHour[0] + '.' + noHour[1] + '.' + noHour[2];
    }

    public init() {
        this.state = {
            userName: '未知',
            avatar: '',
        };
    }

    public componentWillMount() {
        const id = this.props.match.params.id;
        this.getDetail(id);
    }

    public componentDidMount() {
        document.title = '问答详情';
    }

    public render() {
        const { className, match, route, history } = this.props;
        const { getDetail } = this.props.store;
        const { userName, avatar } = this.state;
        const imgList = getDetail.images && getDetail.images.map((item, idx) => {
            return <img key={idx} src={item.imageUrl} alt="" />;
        });
        let content = getDetail.description;
        content = tool.htmlEncode(content);
        content = content && content.replace(/\n/g, '<br/>');
        return (
            <div className="questionDetailWrap">
                <div className="detailHeader">
                    <div className="headerBox">
                        <div className="loginLogo">
                            <a href="/"><img src={require('../../assets/images/commonImg/lixiang_logo_white.png')} alt="" /></a>
                        </div>
                    </div>
                </div>
                <div className="contentBox">
                    <div hidden={getDetail.type !== 6 && getDetail.type !== 7} className="articleTitle">{getDetail.title && getDetail.title}</div>
                    <div hidden={getDetail.type !== 8 && getDetail.type !== 9} className="answerTitle">
                        <p>
                            {getDetail.title && getDetail.title}
                        </p>
                        <p>
                            <span>回答 {getDetail.answerSum}</span>
                            {
                               /*  // tslint:disable-next-line: jsx-no-lambda
                                <span onClick={() => this.checkAnswer(getDetail.id, getDetail.questionProductId, getDetail.status)}>回答</span> */}
                        </p>
                    </div>
                    <div className="pubInfo">
                        <div className="personIco">
                            <img src={getDetail.avatar || avatar || require('../../assets/images/commonImg/personIco.png')} alt="" />
                        </div>
                        <div className="pubTimeAuthor">
                            <div className="pubAuthor">{getDetail.nickname || userName || '游客'}</div>
                            <div className="pubTime">{getDetail.releaseTime && moment(getDetail.releaseTime).format('YYYY.MM.DD')} 发布</div>
                        </div>
                    </div>
                    <div className="detailCon">
                        <p dangerouslySetInnerHTML={{ __html: content }}></p>
                        {/* <p>李想是个独立思考能力特别强的创业者，让每个和他交流过的人都印象深刻。他的公司也不会盲目追随主流方向、做所有人都认为对的事情。这背后并不是刻意不同，而是从本质出发，独立思考后经过实践验证的方法论</p>
                        <p>前不久车和家公布了自己的战略布局，我发现其中自动驾驶业务的做法与众不同，很好奇为什么车和家会做出这样的路径选择，于是找李想聊了聊他的战略判断方法论，思考方法很有意思。</p>
                        <p>今天所有汽车公司都要做两道难解的题目：造什么样的新能源汽车、自动驾驶怎么做。</p>
                        <p>如何选择新能源产品路线，决定了汽车公司，特别是新兴造车公司3年内能不能活下来的关键。而自动驾驶战略方向的选择，决定了5年后他们能不能活下来、能不能成为千亿市值公司的关键。</p>
                        <h3>L3大爆发？</h3>
                        <p>讨论自动驾驶时，L3 显然是个重要话题。</p>
                        <p>奥迪已经推出 L3 自动驾驶硬件的旗舰车型 A8。6月小鹏汽车与德赛西威宣布将合作研发 L3 自动驾驶系统，将在2020年实现 L3 自动驾驶汽车量产。</p>
                        <p>互联网巨头百度还成立了 L3 事业部，比亚迪在2018年4月的百度阿波罗发布会上表示，将在2020年推出 L3 电动车。还有不少自动驾驶创业公司，都在宣称将推出 L3 级别的自动驾驶汽车。</p>
                        <p>L3 是一种有限条件下的自动驾驶，有个变态的要求是：外界条件不符合自动驾驶时，驾驶者要随时接管方向盘。自动驾驶当然会让驾驶员开车更轻松放松注意力，这也是自动驾驶技术的目的之一。但同时又要求驾驶者随时从放松的状态马上切换到注意力集中的状态来处理突发状况。</p>
                        <p>想象一下，和朋友看完热门电影《我不是药神》，你开车回家。在激情的四环路上你启动了 L3 系统，坐在方向盘前琢磨着散伙后，黄毛、脱衣舞女、吕受益他们究竟是靠什么活下来的。</p> */}
                    </div>
                    <div className="postsDetailBanner">
                        {getDetail.videoUrlHigh ? <video src={getDetail.videoUrlHigh} controls={true}>您的浏览器不支持 video 标签。</video> :
                         getDetail.videoUrlSource ? <video src={getDetail.videoUrlSource} controls={true}>您的浏览器不支持 video 标签。</video> :
                         getDetail.images.length > 0 ? imgList : null}
                    </div>
                </div>
            </div>
        );
    }
    public checkAnswer = (id, questionProductId, status) => {
        const { answerList } = this.props.store;
        id = questionProductId || id;  // 如果questionProductId存在就使用，因为可能当前是答案详情
        if (status === 2) {
            answerList.checkAnswer(id).then((res) => {
                if (res) {
                    window.location.href = `/question/response/${id}`;
                } else {
                    toast.warning('该问题您已回答过');
                }
            }).catch((err) => {
                toast.error(err.msg);
            });
        } else {
            toast.error('该问题未通过审核，请稍后回答');
        }

    }
}
